var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtTrc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3117_3909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3117_3909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3117_3909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2549 18V13.3283C16.1052 13.1712 18.2499 12.4888 18.25 11.6712C18.25 10.8537 16.1052 10.1714 13.2551 10.0141L13.2549 8.71131H16.8136V6H7.08278V8.71131H10.6411V10.0204C7.84309 10.1886 5.75 10.8636 5.75 11.6712C5.75 12.4789 7.84309 13.154 10.6411 13.322V18H13.2549ZM13.2551 11.8964V10.3105C15.7094 10.423 17.539 10.8586 17.5391 11.3794C17.5391 11.9857 15.059 12.4768 12 12.4768C8.94077 12.4768 6.46087 11.9857 6.46087 11.3794C6.46087 10.8661 8.23908 10.4353 10.6412 10.3153V10.6242H10.6415V11.8904C11.0745 11.9154 11.5296 11.9288 11.9999 11.9288C12.4327 11.9288 12.8531 11.9173 13.2551 11.8964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -2,
    y: 14,
    width: 29,
    height: 7,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85158 15.38V16.01H6.80158V20H6.17158V16.01H5.12158V15.38H7.85158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1629 17.06H10.3729V16.22H10.1629V16.01H8.90295V17.27H10.1629V17.06ZM11.0029 18.95V20H10.3729V19.16H10.1629V18.74H9.95295V18.32H9.74295V17.9H8.90295V20H8.27295V15.38H10.3729V15.59H10.5829V15.8H10.7929V16.01H11.0029V17.27H10.7929V17.48H10.5829V17.69H10.3729V18.11H10.5829V18.53H10.7929V18.95H11.0029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1543 18.74V19.37H13.9443V19.58H13.7343V19.79H13.5243V20H12.2643V19.79H12.0543V19.58H11.8443V19.37H11.6343V19.16H11.4243V16.22H11.6343V16.01H11.8443V15.8H12.0543V15.59H12.2643V15.38H13.5243V15.59H13.7343V15.8H13.9443V16.01H14.1543V16.64H13.5243V16.22H13.3143V16.01H12.4743V16.22H12.2643V16.43H12.0543V18.95H12.2643V19.16H12.4743V19.37H13.3143V19.16H13.5243V18.74H14.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3057 19.37V20H14.5757V18.32H14.7857V18.11H14.9957V17.9H15.2057V17.69H15.4157V17.48H16.2557V17.27H16.4657V17.06H16.6757V16.22H16.4657V16.01H15.4157V16.22H15.2057V16.64H14.5757V16.01H14.7857V15.8H14.9957V15.59H15.2057V15.38H16.6757V15.59H16.8857V15.8H17.0957V16.01H17.3057V17.27H17.0957V17.48H16.8857V17.69H16.6757V17.9H16.4657V18.11H15.6257V18.32H15.4157V18.53H15.2057V19.37H17.3057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6171 19.16H19.8271V17.06H19.6171V17.48H19.4071V17.9H19.1971V18.32H18.9871V18.74H18.7771V19.16H18.5671V19.37H19.6171V19.16ZM19.4071 16.43H19.6171V16.22V16.01H18.5671V16.22H18.357V18.53H18.5671V18.11H18.7771V17.69H18.9871V17.27H19.1971V16.85H19.4071V16.43ZM20.4571 16.22V19.16H20.2471V19.37H20.0371V19.58H19.8271V19.79H19.6171V20H18.5671V19.79H18.357V19.58H18.1471V19.37H17.937V19.16H17.7271V16.22H17.937V16.01H18.1471V15.8H18.357V15.59H18.5671V15.38H19.6171V15.59H19.8271V15.8H20.0371V16.01H20.2471V16.22H20.4571Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3117_3909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtTrc20);
export default __webpack_public_path__ + "static/media/USDT-TRC20.2d89544abe84c5289df3aefcf734ca53.svg";
export { ForwardRef as ReactComponent };